import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "@/helper/axios";
import { API_PORTAL_URL } from "@/lib/config";
import { IDashboardFilter, IGetDashboardOrderListPayload } from "./dashboardModel";

export const getDashboardCount = createAsyncThunk(
  "Dashboard/GetDashboardCount",
  async (filter: IDashboardFilter) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Dashboard/GetDashboard`,
        filter
      );
      return response.data;
    } catch (error: any) {
      console.error("Error Fetching Dashboard Count:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getDashboardOrderList = createAsyncThunk(
  "Dashboard/GetDashboardOrderList",
  async (payload: IGetDashboardOrderListPayload) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Dashboard/GetOrderList`,
        payload
      );
      return response.data;
    } catch (error: any) {
      console.error("Error Fetching Dashboard Order List:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
